import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'mx-confirm-oneinc-handoff-modal',
  templateUrl: './confirm-oneinc-handoff-modal.component.html',
  styleUrls: ['./confirm-oneinc-handoff-modal.component.scss']
})
export class ConfirmOneIncHandoffModalComponent implements OnInit {

  constructor(private modal: NgbActiveModal) {}

  ngOnInit() {}

  onCancel() {
    this.modal.close({ continue: false });
  }

  onContinue() {
    this.modal.close({ continue: true });
  }

}
